import React, { useCallback, useEffect, useState } from "react";
import { ChoiceGroup, IChoiceGroupOption } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { SerializedBooleanFilter } from "../../../store/tableFilters";
import styled from "styled-components";

type BooleanFilterToggleProps = {
  value: SerializedBooleanFilter;
  onChange: (filter: SerializedBooleanFilter) => void;
  trueLabel?: string;
  falseLabel?: string;
};

export const BooleanFilterToggle = ({
  value,
  onChange,
  trueLabel,
  falseLabel,
}: BooleanFilterToggleProps) => {
  const { t } = useTranslation();
  const [localValue, setLocalValue] = useState<string | null>(
    value.value === null ? null : value.value ? "true" : "false",
  );

  useEffect(() => {
    setLocalValue(value.value === null ? null : value.value ? "true" : "false");
  }, [value.value]);

  const options: IChoiceGroupOption[] = [
    { key: "all", text: t("ram.table.filter.all") },
    { key: "true", text: trueLabel || t("ram.table.filter.yes") },
    { key: "false", text: falseLabel || t("ram.table.filter.no") },
  ];

  const handleChange = useCallback(
    (
      ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
      option?: IChoiceGroupOption,
    ) => {
      if (option) {
        const newValue =
          option.key === "all" ? null : option.key === "true" ? true : false;
        setLocalValue(option.key === "all" ? null : option.key);
        onChange({
          type: "boolean",
          value: newValue,
        });
      }
    },
    [onChange],
  );

  return (
    <Container>
      <ChoiceGroup
        selectedKey={localValue || "all"}
        options={options}
        onChange={handleChange}
        styles={{
          flexContainer: {
            display: "flex",
            flexDirection: "row",
            gap: 16,
          },
        }}
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

export default BooleanFilterToggle;
